import { queryOptions } from '@tanstack/react-query';

import { getPendingDepositQuery } from './shared/apis';

export const getPendingDepositQueryOptions = (id: string) => queryOptions(getPendingDepositQuery(id));
